import { __assign } from 'tslib';
import { fadeIn } from '../animations.js';
import { fonts } from '../typography.js';

var chartGridRow = {
    base: {
        ".visx-line": {
            strokeDasharray: "5px",
            stroke: "black.10",
        },
    },
};
var chartAxisLeft = {
    base: {
        font: "sm",
        fill: "black.40",
    },
};
var chartAxisLeftLabel = {
    base: {
        font: "sm",
        fill: "black.40",
    },
};
var chartAxisLeftTick = {
    base: {
        ".visx-line": { stroke: "black.100" },
    },
};
var chartAxisLeftLine = {
    base: {
        stroke: "black.100",
    },
};
var chartAxisBottom = {
    base: {
        font: "sm",
        fill: "black.100",
    },
};
var chartAxisBottomLabel = {
    base: {
        font: "sm",
        fill: "black.40",
    },
};
var chartAxisBottomTick = {
    base: {
        ".visx-line": { stroke: "black.100" },
    },
};
var chartAxisBottomLine = {
    base: {
        stroke: "black.100",
    },
};
var chartLinePath = {
    base: { stroke: "black.80", strokeWidth: 4 },
};
var xyChartAreaClosed = {
    base: { fill: "black.80", opacity: 0.1 },
};
var chartResponsive = {
    base: {
        p: "40px 70px 55px 70px",
        boxSizing: "border-box",
        width: "100%",
        height: "360px",
        ">[data-ref-box]": {
            width: "100%",
            height: "100%",
            ">svg": {
                overflow: "visible",
            },
        },
    },
};
var chartTooltip = {
    base: {
        foreignObject: {
            overflow: "visible",
        },
        "[data-chart-tooltip-guide-line]": {
            stroke: "black.40",
            strokeDasharray: "1,2",
            transition: "all ease-out",
            transitionDuration: 6,
        },
        "[data-chart-tooltip]": __assign(__assign({ boxShadow: "0 4px 8px 0 var(--colors-shadow), 0 2px 4px 0 var(--colors-shadow) !important", p: "16px !important" }, fonts.sm), { opacity: 0, transition: "all ease-out", transitionDuration: 5, animationName: fadeIn, animationDuration: 5, animationDelay: 5, animationFillMode: "forwards" }),
    },
};
var chartTooltipGuideDot = {
    base: {
        fill: "black.80",
        stroke: "white",
        strokeWidth: 2,
    },
};
var chartLegends = {
    base: { font: "xs", color: "black.60" },
};
var chartLegend = {
    base: __assign(__assign({ alignItems: "start" }, fonts.xs), { lineHeight: "1.25rem", color: "black.60" }),
};
var chartLegendLabel = {
    base: {},
};
var chartLegendIconBox = {
    base: {
        color: "black.80",
        fontSize: "iconSm",
    },
    variants: { size: {} },
};
var chartTitle = {
    base: __assign({ gridArea: "title", m: 0, mb: 4 }, fonts.h5),
};
var chartSubTitle = {
    base: __assign(__assign({}, fonts.xs), { gridArea: "subTitle", mt: -2, mb: 0, color: "black.80" }),
};
var chartFilters = {
    base: { gridArea: "filters", gap: 4 },
};
var chartHeader = {
    base: {
        gap: 0,
        gridTemplate: [
            " \n     \"title\" auto\n     \"subTitle\" auto\n     \"filters\" auto\n   ",
            " \n     \"title filters\" auto\n     \"subTitle filters\" auto\n     / 1fr auto\n   ",
        ],
    },
};
var chartContainer = {
    base: { display: "flex", gap: 5, flexDirection: "column" },
};
var chartBar = {
    base: { fill: "black.60" },
};
var chartFiltersFlex = {
    base: __assign(__assign({}, chartFilters.base), { display: "flex", flexDirection: "column", alignItems: "flex-end", mb: 0 }),
};

export { chartAxisBottom, chartAxisBottomLabel, chartAxisBottomLine, chartAxisBottomTick, chartAxisLeft, chartAxisLeftLabel, chartAxisLeftLine, chartAxisLeftTick, chartBar, chartContainer, chartFilters, chartFiltersFlex, chartGridRow, chartHeader, chartLegend, chartLegendIconBox, chartLegendLabel, chartLegends, chartLinePath, chartResponsive, chartSubTitle, chartTitle, chartTooltip, chartTooltipGuideDot, xyChartAreaClosed };
//# sourceMappingURL=chart.js.map
